import React, {useRef} from 'react';
import Player from 'react-player';

export default ({
  toc
}) => {
  const player = useRef(null);
  const handleProgress = (({playedSeconds}) => {
    if (player && player.current && playedSeconds > 66) {
      player.current.seekTo(2, 'seconds');
    }
  })
  return (
    <>
      <main className="content-container">
        <h2>Enquête sur EME</h2>
        <p>
        “Une enquête sur les modes d’existence” est un projet de philosophie empirique conduit au moyen d’un dispositif d’enquête complexe qui associe des publications imprimées, des espaces numériques et des rencontres diplomatiques.
        </p>
        <p>
          Ce site présente les premiers résultats d'une enquête visant à reconstituer l'histoire de sa conception, du point de vue des choix techniques et esthétiques réalisés et de leur interaction avec le calendrier du projet, ses développements philosophiques, et la relation à son public de lecteurs et de contributeurs.
        </p>
        <p>
          Quel a été le rôle des pratiques de design et de conception informatique dans la constitution de la méthodologie du projet ?
          Comment les différentes cultures disciplinaires et approches professionnelles ont-elles dialogué (ou non) pour fabriquer les différentes instances du projet ?
          Comment en est-on arrivé à la spécifique pratique de la "contribution" en ligne au centre des discussions externes sur l'EME ?
        </p>
        <p>
          Cet ensemble de questions est abordé dans les interviews que j'ai conduites depuis Mars 2014, ici rapidement thématisées afin de faciliter la lecture.
        </p>
        <p>
          Fidèle à la dimension participative et réflexive de son objet d'étude, l'objet de cette production est de faire office de pierre d'achoppement et de vecteur d'ellicitation pour les discussions internes à l'équipes quant au bilan de l'EME et aux directions futures.
        </p>
        <p>
          <i>Robin de Mourat, doctorant contractuel en arts & design, Université Rennes 2.</i>
        </p>
      </main>
      <aside>
        <div className="player-container">
          <Player 
            ref={player} 
            onProgress={handleProgress} 
            controls 
            loop 
            url="https://player.vimeo.com/video/114275030?title=0&portrait=0&badge=0&autoplay=1&app_id=122963" 

            playing={true}
            autoPlay
          />
        </div>
      </aside>
    </>
  )
}